import React, { useEffect, useState } from 'react';
import InfinityLoader from '../dropdownSearch/infinityLoader';
import API from '../../services/api';
import utils from '../../utils';

const CampaignSelector = ({ company, customLabel = 'Campaign', outline = false, onSelection, reload }) => {
  const [currentCampaigns, setCurrentCampaigns] = useState([]);
  const [totalCampaigns, setTotalCampaigns] = useState(0);
  const [currentFilter, setCurrentFilter] = useState('');

  useEffect(() => {
    if (company) {
      onLoadCampaigns();
    }
  }, []);

  useEffect(() => {
    if (reload && reload.trim() !== '') {
      onLoadCampaigns();
    }
  }, [reload]);

  const handleCampaignSelector = campaignId => {
    const selected = currentCampaigns.find(c => c.value === campaignId);
    if (!selected) return;
    onSelection(selected.data);
  };

  const onLoadCampaigns = (nextPageToken, searchingBy = '') => {
    const hasSearch = searchingBy && searchingBy.trim() !== '';
    const query = encodeURI(`displayName ILIKE "%${searchingBy}%" OR id ILIKE "%${searchingBy}%"`);
    const filter = hasSearch ? `brandPortalId IS NULL AND ${query}` : 'brandPortalId IS NULL';

    if (filter !== currentFilter) {
      setCurrentCampaigns([]);
    }

    return API.getCampaigns(company.id, nextPageToken, filter, 40, 'displayName, id').then(res => {
      setTotalCampaigns(res.totalSize);
      const fetchedCampaigns = res.campaigns.map(campaign => ({
        label: `${campaign?.displayName} - ${campaign?.id}`,
        value: campaign?.id,
        data: campaign
      }));

      // Reset list when filter changes
      if (filter !== currentFilter) {
        setCurrentFilter(filter);
        setCurrentCampaigns(fetchedCampaigns);
      } else {
        const newCampaigns = utils.mergeArraysByField(fetchedCampaigns, currentCampaigns, 'value');
        setCurrentCampaigns(newCampaigns);
      }

      return res.nextPageToken;
    });
  };

  if (company) {
    return (
      <div className="campaign-selector">
        <InfinityLoader
          title={'Search Campaign'}
          label={customLabel}
          leftAlign
          outline={outline}
          onSelect={handleCampaignSelector}
          onLoading={onLoadCampaigns}
          totalSize={totalCampaigns}
          options={currentCampaigns}
        />
      </div>
    );
  }

  return null;
};

export default CampaignSelector;
